import { InterviewService } from "../../../../../services/InterviewService";
import { Managers } from "../../components/Managers";
import { order } from "../SmartSearchParammeter";

export default async function ManagerSearchConfig(key) {
  let managers = await InterviewService.GetManagerList();
  return {
    description: "Managers",
    id: "managerId",
    initial: [],
    type: order.second,
    handleValues: (searchObject) => {
      return;
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <Managers searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact"],
    list: managers.map((m) => m.nickname.replace(/,/g, "#")),

    handler: function (searchObj, value) {
      searchObj["managerId"] = managers
        .filter((m) => value[0] == m.nickname.replace(/#/g, ",").trim())
        .map((m) => m.id)
        .shift();
    }
  };
}
